/** Le fil, les publications et leurs reponses. */
export const fil = {
  erreurs: {
    supprimerLesSiens: 'Tu ne peux supprimer que tes propres posts',
    pasTaReponse: 'Cette réponse ne t’appartient pas',
    commentaireVide: 'Commentaire vide',
    vide: 'Écris quelque chose avant de publier',
    tropLong: (max: number) => `${max} caractères maximum`,
  },
  commun: {
    retirerLike: 'Retirer le like',
    liker: 'Liker',
    likerReponse: 'Liker cette réponse',
    retirerSignet: 'Retirer des signets',
    enregistrer: 'Enregistrer dans mes signets',
    actionsPost: 'Actions sur ce post',
    actionsReponse: 'Actions sur cette réponse',
    voirPhoto: 'Voir la photo en plein écran',
    photoDe: (auteur: string) => `Photo publiée par ${auteur}`,
    supprimerPostQ: 'Supprimer ce post ?',
    supprimerPost: 'Supprimer ce post',
    supprimerReponseQ: 'Supprimer cette réponse ?',
    supprimerReponse: 'Supprimer cette réponse',
    signaler: 'Signaler le contenu',
    partager: 'Partager',
    suppressionImpossible: 'Suppression impossible.',
    reponses: 'Réponses',
    commenter: 'Commenter',
  },
  signets: {
    onglets: {
      posts: 'Posts',
      evenements: 'Événements',
    },
    titre: 'Mes signets',
    aucunPost: 'Aucun post enregistré',
    aucunPostAide: 'Enregistre un post ou une réponse pour le retrouver ici.',
    aucuneSortie: 'Aucun événement enregistré',
    aucuneSortieAide: "Touche le signet sur la fiche d'un événement pour le garder sous la main.",
    compte: (n: number) => `${n} enregistré${n > 1 ? 's' : ''}`,
  },
  cloche: {
    verbes: {
      like: 'a aimé ton post',
      commentaire: 'a répondu à ton post',
      mention: "t'a cité dans un post",
      signet: 'a enregistré ton post',
    },
    titre: 'Notifications',
    activite: 'Activité',
    vide: 'Aucune activité pour l’instant',
    nouvelles: (n: number) => `Notifications · ${n} nouvelles`,
  },
  composeur: {
    annulerReponse: 'Ne plus répondre à cette réponse',
    ecrire: 'Écrire un commentaire...',
    envoyer: 'Envoyer',
    reponseA: 'Réponse à',
    repondreA: (nom: string) => `Répondre à ${nom}...`,
  },
  reponse: {
    voirReponses: (n: number) => `Voir les ${n} réponses`,
    repondreA: (nom: string) => `Répondre à ${nom}`,
  },
  fil: {
    envoiImpossible: 'Réponse impossible à envoyer',
    partagerReponse: 'Partager cette réponse',
    vide: 'Aucune réponse',
    videAide: 'Sois le premier à répondre à ce commentaire.',
  },
  commentaires: {
    envoiImpossible: 'Commentaire impossible à envoyer',
    titre: 'Commentaires',
    vide: 'Aucun commentaire',
    videAide: 'Sois le premier à réagir à ce post.',
  },
  composer: {
    impossible: 'Publication impossible',
    titre: 'Nouveau post',
    publier: 'Publier',
    lieu: 'Lieu',
    evenement: 'Événement',
    photoJointe: 'Photo jointe au post',
    retirerPhoto: 'Retirer la photo',
    visible: 'Visible par tout le serveur',
    remplacerPhoto: 'Remplacer la photo',
    ajouterPhoto: 'Ajouter une photo',
    ajouterLieu: 'Ajouter un lieu',
    joindreEvenement: 'Joindre un événement',
    ajouterCeLieu: 'Ajouter ce lieu',
    retirerLieu: 'Retirer le lieu',
    termine: 'Terminé',
    retirer: 'Retirer',
    quelEvenement: 'Quel événement ?',
    aucunEvenement: 'Aucun événement à venir',
    aucunEvenementAide: "Crée-en un depuis l'onglet Événements.",
    quoiDeNeuf: (lieu: string) => `Quoi de neuf à ${lieu} ?`,
    lieuChoisi: (lieu: string) => `Lieu : ${lieu}`,
    evenementChoisi: (titre: string) => `Événement : ${titre}`,
    ouDans: (lieu: string) => `Où dans ${lieu} ?`,
  },
  ecran: {
    vues: {
      pourToi: 'Pour toi',
      recent: 'Récent',
    },
    supprime: 'Post supprimé.',
    rechercher: 'Rechercher un post…',
    rechercherLabel: 'Rechercher dans le feed',
    ecrire: 'Écrire un post',
    masquerQ: 'Masquer ce post ?',
    masquer: 'Masquer ce post',
    aucunResultat: 'Aucun résultat',
    vide: 'Le feed est encore vide',
    videAide: 'Sois le premier à lancer une discussion sur ce serveur.',
    premierPost: 'Écrire le premier post',
    rienNeCorrespond: (recherche: string) => `Rien ne correspond à « ${recherche} » dans ce serveur.`,
  },
  mesPosts: {
    titre: 'Mes posts',
    voirQuiAAime: 'Voir qui a aimé',
    jaime: 'J’aime',
    personne: 'Personne n’a encore aimé ce post.',
    vide: 'Aucun post',
    videAide: 'Tes publications apparaîtront ici.',
    compte: (n: number) => `${n} post${n > 1 ? 's' : ''}`,
  },
};
